// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const litten: PokeData = {
  "id": 725,
  "name": "litten",
  "height": 4,
  "weight": 43,
  "base_experience": 64,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "scratch",
    "double-kick",
    "thrash",
    "leer",
    "bite",
    "growl",
    "roar",
    "ember",
    "flamethrower",
    "lick",
    "fury-swipes",
    "scary-face",
    "outrage",
    "swagger",
    "flare-blitz",
    "fire-fang"
  ],
  "moves": [
    "scratch",
    "double-kick",
    "leer",
    "bite",
    "growl",
    "ember",
    "flamethrower",
    "lick",
    "scary-face",
    "outrage",
    "flare-blitz",
    "fire-fang",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 375,
    "item": null,
    "species": [
      {
        "name": "litten",
        "order": 725,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "torracat",
        "order": 726,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 725,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "incineroar",
        "order": 727,
        "types": [
          PokeType.FIRE,
          PokeType.DARK
        ],
        "evolves_from_species_id": 726,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 70,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
